import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import selectReportParametersDialog from '../dialog.selectReportParameters';
import controller from './select-report-types-dialog.controller';
import template from './select-report-types-dialog.html';

class dialogService {
  getOptions($event, { hasAdvisoryServices, reportPackage }) {
    return {
      controller,
      controllerAs: 'selectReportTypesDialogVM',
      locals: {
        hasAdvisoryServices,
        reportPackage,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.selectReportTypesDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
    selectReportParametersDialog
  ])
  .service('selectReportTypesDialog', dialogService).name;
